// Module
var code = "<!-- ko with: _editor --> <!-- ko template: {name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data)} --><!-- /ko --> <!-- /ko --> ";
// Exports
export default code;